<template>
    <section>
        <div class="application_section">
            <div class="container ">
                <div class="row">
                    <div class="col-12 col-md-8 col-offset-md-4 ">
                        <h1 class="mb-4"> أطلق تطبيق الخدمات الإلكترونية لوزارة الداخلية <br/> 
                            قطاع الأحوال المدنية  
                        </h1>
                        <div class="appLinks">
                            <a href="https://apps.apple.com/us/app/وزارة-الداخلية-المصرية/id1459563811?ls=1"><img src="@/assets/images/appleStore.png" alt="app Store" class="img-fluid"> </a>
                            <a href="https://play.google.com/store/apps/details?id=moi.com.excel.moi"><img src="@/assets/images/googleStore.png" alt="google play" class="img-fluid me-3" > </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
  name: 'AppComp',
}
</script>